module.exports = __webpack_public_path__ + "img/12_004.121c03a6.webp";